class YoutubePlaceholder {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.replaceBlockedYoutube();
    }

    replaceBlockedYoutube() {
        // Cookiebot adds `data-cookieblock-src` to any elements it has blocked. Get all these, where the src is from youtube or youtube-nocookie
        const iframes = document.querySelectorAll('[data-cookieblock-src*="youtube"]');

        iframes.forEach(e => {
            // Get ID from src
            const src = e.dataset.cookieblockSrc;
            const videoId = src.match(/\/embed\/([a-zA-Z0-9_-]+)/)[1] ?? null;

            // Prepare poster image and playUrl
            const poster = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
            const playUrl = `https://www.youtube.com/watch?v=${videoId}`

            // Build HTML placeholder
            const placeholder = `
                <div class="youtube-placeholder">
                    <img src="${poster}">
                    <a href="${playUrl}" target="_blank">
                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                            <rect width="60" height="60" rx="30" fill="#fff"/>
                            <path d="m38.784 30.521-13.846 7.994V22.527l13.846 7.994Z" fill="#FF2B2B"/>
                        </svg>
                        <span class="u-sr-only">Watch on Youtube</span>
                    </a>

                    <p>
                        Pressing play will open Youtube. <a href="javascript:Cookiebot.renew()">Enable cookies</a> to view inline instead.</p>
                </div>
            `

            // Append placeholder
            e.parentNode.insertAdjacentHTML('beforeend', placeholder);
        });
    }

    static init() {
        new YoutubePlaceholder();
    }
}

export default YoutubePlaceholder;